import React from "react";

interface StatItem {
    value: string;
    label: string;
}

interface GallaboxAtAGlanceProps {
    title?: string;
    stats?: StatItem[];
}

const defaultStats: StatItem[] = [
    { value: "~10K", label: "Customer base" },
    { value: ">1.2Bn", label: "Conversations" },
    { value: "200Mn", label: "Automated conversations" },
    { value: "150+", label: "Global resellers" },
];

const GallaboxAtAGlance: React.FC<GallaboxAtAGlanceProps> = ({ title = "Gallabox at a glance", stats = defaultStats }) => {
    return (
        <section
            style={{
                background: "#D2DCFA",
            }}
            className="py-20"
        >
            <div className="max-w-7xl mx-auto px-5">
                <h2 className="text-6xl font-semibold mb-10" style={{ fontFamily: "Degular Display", color: "black" }}>
                    {title}
                </h2>
                <div className="grid md:grid-cols-4 gap-6">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="bg-white p-6 flex flex-col relative"
                            style={{ boxShadow: "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)" }}
                        >
                            <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: "#3364FA" }}></div>
                            <p className="text-6xl font-bold mb-2" style={{ fontFamily: "Degular Display", color: "black" }}>
                                {stat.value}
                            </p>
                            <p className="text-base" style={{ color: "black" }}>
                                {stat.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GallaboxAtAGlance;
